import { FilterDocument, TaskFilterOptions } from '@griply/types';
import { getFilterDocumentOptions } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useTags } from 'features/tags';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useRelationships } from 'shared/hooks/use-relationships';
import { useUser } from 'shared/hooks/use-user';
import { LifeArea } from 'shared/types/life-area';

export type Options = {
  uncompletedOnly?: boolean;
  includeTaskWithAction?: boolean;
  excludeHiddenTodoHabits?: boolean;
  includeArchivedGoals?: boolean;
  includeArchived?: boolean;
};

export const useFilterDocumentFilters = (
  filterDocument: FilterDocument,
  {
    uncompletedOnly,
    includeTaskWithAction,
    excludeHiddenTodoHabits,
    includeArchivedGoals = false,
    includeArchived = false,
  }: Options,
) => {
  const today = useToday();
  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();
  const user = useUser();
  const relationships = useRelationships();
  const tags = useTags();

  return useMemo<TaskFilterOptions[]>(
    () =>
      getFilterDocumentOptions({
        filterDocument,
        goals,
        tags,
        relationships,
        lifeAreas: lifeAreas as LifeArea[],
        user,
        today,
        uncompletedOnly,
        includeTaskWithAction,
        excludeHiddenTodoHabits,
        includeArchivedGoals,
        includeArchived,
      }),
    [
      filterDocument,
      goals,
      tags,
      relationships,
      lifeAreas,
      user,
      today,
      uncompletedOnly,
      includeTaskWithAction,
      excludeHiddenTodoHabits,
      includeArchivedGoals,
      includeArchived,
    ],
  );
};
